<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from './components/popup'
import { mapState } from 'vuex'
export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(['loading', 'browser'])
  },
  created () {
    let lang = localStorage.getItem('cdb_lang')
    if (this.browser === 'wechat' && !lang) {
      this.$i18n.locale = 'zh-CN'
      this.$store.commit('lang', 'zh-CN')
    }
  }
}
</script>

<style lang="less">
@import url('./assets/fonts/font.less');
body {
  font-family: MyriadPro;
  background: #F9F9F9;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #333333;
}
#app {
  font-size: 28px;
}
.btn {
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: #409EFF;
  font-size: 32px;
  border-radius: 20px;
}
</style>
